<template>
  <div
    :style="styles"
    class="pb-3 px-0 d-print-none d-flex flex-column justify-space-between"
  >
    <div class="px-4">
      <div
        class="text-center d-flex flex-column justify-center align-center mt-0"
      >
        <v-img
          :src="getImgBrand(globalBrand)"
          contain
          height="70"
          style="max-width:180px"
          class="rounded-md my-4"
        ></v-img>
        <BrandInput
          :disabled="
            [
              'Manage users',
              'ProductCreate',
              'Product',
              'BrandCreate'
            ].includes($route.name)
          "
          v-model="globalBrand"
          with-all-brands
        ></BrandInput>
      </div>
      <div class="text-h5 px-1 pl-6 mb-3 mt-1 primary--text font-weight-medium">
        <v-icon color="primary" class="mr-3">{{ parent.icon }}</v-icon>
        {{ parent.title }}
      </div>

      <v-list nav>
        <v-list-item
          v-for="(link, i) in links.filter(l =>
            l.isAllowed !== undefined ? l.isAllowed(this) : true
          )"
          :key="i"
          exact
          :to="link.to"
        >
          <v-list-item-avatar>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-avatar>

          <v-list-item-title v-text="link.title" />
        </v-list-item>
      </v-list>
    </div>
    <v-slide-y-transition mode="out-in">
      <ProductDrawerFilters v-if="$route.name === 'Catalog'" />
      <BrandDrawerFilters
        v-if="$route.name === 'Brand' && !(hasSelectedBrand || brandId)"
      />
    </v-slide-y-transition>
  </div>
</template>

<script>
import BrandInput from "@/components/inputs/BrandInput.vue"
// Utilities
import { ProductDrawerFilters, BrandDrawerFilters } from "@/components"
import { AccountService, BrandService } from "@/services"
import { mapMutations, mapState } from "vuex"
export default {
  components: {
    ProductDrawerFilters,
    BrandDrawerFilters,
    BrandInput
  },
  props: {
    parent: {
      type: Object,
      default: null
    },
    links: {
      type: Array,
      default: () => []
    },
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    brandId() {
      return this.$route.params.brand
    },
    hasSelectedBrand() {
      return !!this.$store.state.globalBrand?.id
    },
    globalBrand: {
      get() {
        return this.$store.state.globalBrand
      },
      set(v) {
        this.$store.commit("setGlobalBrand", v)
      }
    },
    styles() {
      return {
        width: "300px",
        padding: "0px 10px",
        background: "#ffffff",
        boxShadow: "0 0 2rem 0 rgba(136,152,170,.15)"
      }
    },
    ...mapState("app", ["image", "color"]),
    drawer: {
      get() {
        return this.$store.state.app.drawer.main
      },
      set(val) {
        this.setSecondaryDrawer(val)
      }
    }
  },
  // created () {
  //   this.links =
  //     DrawerLinks[this.$store.state.user.admin ? 'admin' : 'default']
  // },
  watch: {
    $route(newVal, oldVal) {
      if (newVal) {
        BrandService.all(this).then(result => {
          this.$store.commit("setBrands", result)
        })
      }
    }
  },
  methods: {
    ...mapMutations("app", ["setSecondaryDrawer"]),
    handleReturnToAdmin() {},
    getImgBrand(item) {
      if (item) {
        return item["image_url"]
          ? item["image_url"]
          : "@/assets/logo_black_no_text.png"
      }
    },

    handleLogout() {
      AccountService.logout()
    }
  }
}
</script>
<style lang="scss">
.v-list-item__title {
  font-size: 1.1rem;
}
.filters {
  overflow: auto;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding: 20px 23px;
  height: 500px;
  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    transition: 0.3s all;
    background: #fd656f;
    margin-right: 10px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #d1424b;
  }
}
</style>
